import Job from '@/models/job';

export class JobClaim {
  public claimedByDateTime: Date | null;
  public claimedByUserEmail: string | null;
  public claimedByUserName: string | null;
  public claimedByUserId: string | null;

  constructor(
    claimedByUserId?: string | null,
    claimedByUserName?: string | null,
    claimedByUserEmail?: string | null,
    claimedByDateTime?: Date | null,
  ) {
    this.claimedByDateTime = claimedByDateTime || null;
    this.claimedByUserEmail = claimedByUserEmail || null;
    this.claimedByUserId = claimedByUserId || null;
    this.claimedByUserName = claimedByUserName || null;
  }

  fillFromJob(job: Job): JobClaim {
    this.claimedByDateTime = job.claimedByDateTime || null;
    this.claimedByUserEmail = job.claimedByUserEmail;
    this.claimedByUserId = job.claimedByUserId;
    this.claimedByUserName = job.claimedByUserName;
    return this;
  }

  fillFromJobClaim(jobClaim: JobClaim): JobClaim {
    this.claimedByDateTime = jobClaim.claimedByDateTime || null;
    this.claimedByUserEmail = jobClaim.claimedByUserEmail;
    this.claimedByUserId = jobClaim.claimedByUserId;
    this.claimedByUserName = jobClaim.claimedByUserName;
    return this;
  }
}
